// extracted by mini-css-extract-plugin
export var ErrorModalBody = "api-error-notification-module--ErrorModalBody--+C0xu";
export var ErrorModalButtonContainer = "api-error-notification-module--ErrorModalButtonContainer--Kikm3";